import React, { useState } from 'react';
import styles from './style.module.css';
import { useEffect } from 'react';
import LoadingOverlay from '../../../Components/LoadingOverlay';
import { Button } from '../../../Components';
import Modal from 'react-modal';
import PainReportFilterTool from '../../../Components/ReportFilterTool/PainReportFilterTool';
import ModalStatus from '../../../Components/ReportFilterTool/ModalStatus';

import HealthHeader from '../../../Components/HealthHeader';
import HealthCards from '../../../Components/HealthCard';
import HealthPatientStatsTable from '../../../Components/HealthPatientStatsTable';
import { getPainMetrics } from '../../../services/kollectaHealthCore';

const Home = () => {
  const [loading, setLoading] = useState(true);
  const [modal, setModal] = useState(false);
  const [modalFeedback, setModalFeedback] = useState(false);
  const [painMetricsData, setPainMetricsData] = useState(null);

  const closeFiltersModal = () => {
    setModal(false);
  }

  const closeStatusModal = () => {
    setModal(false);
    setModalFeedback(false);
  }

  useEffect(() => {
    const fetchData = async () => {
      try {
        console.log('Buscando métricas de dor...');
        const response = await getPainMetrics();
        console.log('Resposta da API:', response);
        
        if (response && response.data) {
          setPainMetricsData(response.data);
        } else {
          console.error('Estrutura de resposta inesperada:', response);
          setPainMetricsData(response);
        }
      } catch (error) {
        console.error('Erro ao buscar os dados:', error);
        setPainMetricsData({
          uniquePainPatients: 0,
          botHistoryMetrics: { percentage: '0.00' },
          painLevelMetrics: {
            mild: { total: 0, percentage: '0.00' },
            moderate: { total: 0, percentage: '0.00' },
            severe: { total: 0, percentage: '0.00' },
            anyPain: { total: 0, percentage: '0.00' },
            noPain: { total: 0, percentage: '0.00' }
          }
        });
      } finally {
        setLoading(false);
      }
    };
  
    fetchData();
  }, []);

  useEffect(() => {
    console.log('Dados de métricas de dor atualizados:', painMetricsData);
  }, [painMetricsData]);

  const data = [
    { 
      value: painMetricsData?.uniquePainPatients || 0, 
      label: 'PACIENTES CADASTRADOS' 
    },
    { 
      value: `${painMetricsData?.botHistoryMetrics?.percentage || '0.00'}%`, 
      label: 'ÍNDICE DE ADESÃO AO ESTUDO' 
    }
  ];

  const headers = ['PACIENTES', 'CONTAGEM', 'ÍNDICE'];

  const tableData = [
    {
      description: 'Pacientes que apresentaram dor leve',
      count: painMetricsData?.painLevelMetrics?.mild?.total || 0,
      percentage: `${painMetricsData?.painLevelMetrics?.mild?.percentage || '0.00'}%`,
      color: '#266400'
    },
    {
      description: 'Pacientes que apresentaram dor moderada',
      count: painMetricsData?.painLevelMetrics?.moderate?.total || 0,
      percentage: `${painMetricsData?.painLevelMetrics?.moderate?.percentage || '0.00'}%`,
      color: '#786C00'
    },
    {
      description: 'Pacientes que apresentaram dor grave',
      count: painMetricsData?.painLevelMetrics?.severe?.total || 0,
      percentage: `${painMetricsData?.painLevelMetrics?.severe?.percentage || '0.00'}%`,
      color: '#B41411'
    },
  ];

  const totalData = 
  {
    description: 'Total de pacientes que apresentaram algum nível de dor',
    count: painMetricsData?.painLevelMetrics?.anyPain?.total || 0,
    percentage: `${painMetricsData?.painLevelMetrics?.anyPain?.percentage || '0.00'}%`,
    color: '#FFFFFF'
  }

  const noPainData = 
  {
    description: 'Pacientes que não apresentaram dor',
    count: painMetricsData?.painLevelMetrics?.noPain?.total || 0,
    percentage: `${painMetricsData?.painLevelMetrics?.noPain?.percentage || '0.00'}%`,
    color: '#FFFFFF'
  }

  return (
    <div className={styles.container}>
      <LoadingOverlay isLoading={loading} />
      <HealthHeader title="Dashboard de Pacientes" />
      <div className={styles.content}>
        <div className={styles.buttonContainer}>
          <Button onClick={() => setModal(true)}>Exportar Relatório</Button>
        </div>
        <HealthCards items={data} />
        <HealthPatientStatsTable 
          header={headers} 
          data={tableData} 
          totalData={totalData}
          noPainData={noPainData}
        />
      </div>

      {!modalFeedback && 
        <Modal
          isOpen={modal}
          onRequestClose={closeFiltersModal}
          style={{
            overlay: {
              backgroundColor: 'rgba(0, 0, 0, 0.75)',
            },
            content: {
              top: '50%',
              left: '50%',
              right: 'auto',
              bottom: 'auto',
              marginRight: '-50%',
              transform: 'translate(-50%, -50%)',
              borderRadius: '8px',
              width: '615px',
            },
          }}
        > 
          <div className={styles.modalContainer}>
            <PainReportFilterTool closeModal={closeFiltersModal} setFeedback={setModalFeedback} />
          </div>
        </Modal>  
      }

      <ModalStatus type={modalFeedback} onClose={closeStatusModal} />
    </div>
  );
};

export default Home; 